import { useEffect } from "react";
import {
  Modal as PolarisModal,
  Card,
} from "@shopify/polaris";

export default function Modal({
  open,
  onClose,
  children,
}) {
  // 按 ESC 关闭
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape" && open) onClose();
    };
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, [open, onClose]);

  return (
    <>
      {open ? (
        <>
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.1)",
              zIndex: 9998,
              backdropFilter: "blur(4px)",
            }}
            onClick={onClose}
          />
          <div
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "90%",
              maxWidth: "520px",
              maxHeight: "90vh",
              background: "white",
              borderRadius: "8px",
              boxShadow:
                "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
              zIndex: 9999,
              overflow: "hidden",
            }}
          >
            <Card roundedAbove="sm">
              {children}
            </Card>
          </div>
        </>
      ) : (
        ""
      )}
    </>
  );
}
